import script from "./ClientsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsListView.vue?vue&type=script&setup=true&lang=js"

import "./ClientsListView.vue?vue&type=style&index=0&id=541d0ca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541d0ca0"]])

export default __exports__